<template>
  <v-container>
    <!-- <h3 class="headline">BarcodeReader</h3> -->
    <!-- <v-btn v-show="!runScanner" @click="runScanner = !runScanner" type="button" class="btn"><v-icon left>mdi-play-circle</v-icon>Scanner starten</v-btn> -->
    <v-fab-transition>
      <v-btn fab absolute top right dark color="pink" v-show="!runScanner" @click="runScanner = !runScanner" type="button" title="Scanner starten"><v-icon>mdi-plus</v-icon></v-btn>
    </v-fab-transition>
    <v-btn v-show="runScanner" @click="runScanner = !runScanner" type="button" class="btn"><v-icon left>mdi-stop</v-icon>Scanner stoppen</v-btn>

    <ErrorBoundery v-if="runScanner" :stopPropagation="true" class="my-1">
      <BarcodeScanner @decode="onDecode" @loaded="onLoaded"></BarcodeScanner>
    </ErrorBoundery>

    <hr>
    <div v-if="barcode" class="mb-2">
      <p>Barcode wurde erkannt: {{ barcode }}</p>
      <v-alert outlined type="success" v-if="produktGefunden">
        Produkt wurde gefunden: <b>{{ produktGefunden.code }} - {{ produktGefunden.beschreibung }}</b>
      </v-alert>
      <div v-else><p><b>neues Produkt eingeben:</b>
        <v-text-field label="Beschreibung" v-model="beschreibung"></v-text-field>
        <v-btn color="primary" @click="save">speichern</v-btn>
      </p></div>
    </div>

    <v-row class="mt-2">
      <h3 class="headline">Produkttabelle <small>(gespeichert in deinem Browser)</small></h3>
      <v-simple-table v-if="produkte.length > 0">
        <thead>
          <tr><th>Code</th><th>Beschreibung</th><th></th></tr>
        </thead>
        <tbody>
          <tr v-for="produkt in produkte" :key="produkt.code">
            <td>{{ produkt.code }}</td>
            <td>{{ produkt.beschreibung }}</td>
            <td><v-btn @click="deleteProdukt(produkt.code)" class="error" title="löschen"><v-icon left>mdi-trash-can</v-icon>löschen</v-btn></td>
          </tr>
        </tbody>
      </v-simple-table>
      <p v-else class="text-center">es sind noch keine Produkte gespeichert, bitte "Scanner starten" drücken und loslegen</p>
    </v-row>
  </v-container>
</template>

<script>
import BarcodeScanner from "@/components/BarcodeScanner"
import ErrorBoundery from '@/components/ErrorBoundery'

  export default {
    name: 'SimpleTest',
    components: { BarcodeScanner, ErrorBoundery },

    data: function() {
      return {
        barcode: '',
        beschreibung: '',
        runScanner: false,
        produkte: [],
      }
    },
    methods: {
      onDecode( result ) {
        this.barcode = result
        this.runScanner = false
      },
      onLoaded() {
        console.log('Scanner wurde geladen')
      },
      save() {
        this.produkte.push({ code: this.barcode, beschreibung: this.beschreibung })
        this.barcode = this.beschreibung = ''
      },
      deleteProdukt(code) {
        console.log(code)
        this.produkte.splice(this.produkte.findIndex(p => p.code === code), 1)
      },
    },
    computed: {
      produktGefunden() {
        return this.produkte.find(p => p.code === this.barcode)
      },
    },
    watch: {
      produkte: {
        handler() {
          console.log('Produkte changed!');
          localStorage.setItem('produkte', JSON.stringify(this.produkte));
        },
        deep: true,
      },
    },
    mounted() {
      if (localStorage.getItem('produkte')) this.produkte = JSON.parse(localStorage.getItem('produkte'));
    }
  }
</script>

<style scoped>
  .h3 { background-color: lightgreen; }
  .btn { font-weight: bold; }
</style>
